module.exports = __webpack_public_path__ + "img/dizzy-robot-dark.df61056e.svg";